import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import Vant from 'vant';
import axios from '@/apis/index'
import htmlToPdf from '@/utils/htmlToPdf';
import { Base64 } from 'js-base64';
import ElementUI from 'element-ui';

// 在桌面端自动将mouse事件转换为对应的touch事件
import '@vant/touch-emulator';

import 'vant/lib/index.css';
import 'vant/lib/icon/local.css'
import '@/assets/iconfont/iconfont.css'

import 'element-ui/lib/theme-chalk/index.css';

import tabbar from '@/components/Tabbar.vue'
import iconPlus from '@/components/iconFormPlus.vue'
Vue.component('tabbar', tabbar)
Vue.component('iconPlus', iconPlus)

Vue.use(Vant).use(htmlToPdf).use(ElementUI)

Vue.config.productionTip = false

Vue.prototype.$get = axios.getAction
Vue.prototype.$post = axios.postAction
Vue.prototype.$put = axios.putAction
Vue.prototype.$Base64 = Base64

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
